import { api, API } from "./api";

export async function downloadCsv(path, filename) {
  try {
    const r = await api.get(path, { responseType: "blob" });
    const blob = new Blob([r.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    return true;
  } catch (e) {
    return false;
  }
}
